import type { IFlattenedCategory } from "app/common/services/categoryService.types";
import { getQueryParams } from "app/pages/industry-analysis/common/getQueryParams";
import {
    getFlattenSelectedCategory,
    getSelectedCategory,
} from "app/pages/industry-analysis/common/getSelectedCategory";

import { type GrowthOverviewGranularity, GrowthOverviewMetric, GrowthOverviewSortBy } from "../const";
import type { IndustriesBenchmarkGrowthOverviewListParams } from "../growthOverviewApiTypes";

export const getGrowthOverviewSortBy = (metric: GrowthOverviewMetric): GrowthOverviewSortBy =>
    metric === GrowthOverviewMetric.Unique ? GrowthOverviewSortBy.UniqueUsers : GrowthOverviewSortBy.TotalVisits;

export const normalizeGrowthOverviewSearch = (search: string): string | undefined => {
    const trimmed = search.trim();
    return trimmed.length > 0 ? trimmed : undefined;
};

const resolveGrowthOverviewMainIndustry = (flattenedCategory: IFlattenedCategory | undefined): string | undefined => {
    if (!flattenedCategory) {
        return undefined;
    }

    const { isChild, parentItem, forApi } = flattenedCategory;
    if (isChild) {
        return parentItem?.forApi;
    }

    return forApi;
};

export const buildGrowthOverviewQueryParams = (
    extras: {
        granularity?: GrowthOverviewGranularity;
        sortBy?: GrowthOverviewSortBy;
        search?: string;
        categoryOverride?: string;
        domainOffset?: number;
        domainLimit?: number;
        industryOffset?: number;
        industryLimit?: number;
        subIndustryOffset?: number;
        subIndustryLimit?: number;
    } = {},
): IndustriesBenchmarkGrowthOverviewListParams => {
    const {
        categoryOverride,
        domainOffset,
        domainLimit,
        granularity,
        industryLimit,
        industryOffset,
        sortBy,
        search,
        subIndustryLimit,
        subIndustryOffset,
    } = extras;
    const baseQueryParams = getQueryParams();
    const flattenedCategory = getFlattenSelectedCategory();
    const category = categoryOverride ?? flattenedCategory?.forApi ?? getSelectedCategory()?.forApi ?? "";

    return {
        ...baseQueryParams,
        category,
        mainIndustry: resolveGrowthOverviewMainIndustry(flattenedCategory),
        includeMainOnly: false,
        granularity,
        sortBy,
        search,
        domainOffset,
        domainLimit,
        industryOffset,
        industryLimit,
        subIndustryOffset,
        subIndustryLimit,
    } as IndustriesBenchmarkGrowthOverviewListParams;
};
